import { render, staticRenderFns } from "./InfoTestata.vue?vue&type=template&id=2588b622&scoped=true&"
import script from "./InfoTestata.vue?vue&type=script&lang=js&"
export * from "./InfoTestata.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/preventivi/dialog/infoTestata.css?vue&type=style&index=0&id=2588b622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2588b622",
  null
  
)

export default component.exports